/**
 * Pequeñas Puntadas — purchase configuration.
 *
 * CHECKOUT_URL is the single destination used by every purchase button
 * (hero, offer, closing and mobile sticky bar).
 */
export const CHECKOUT_URL = 'https://pequenas-puntadas.impultienda.ar/checkout'

export const PRICE = {
  value: 24990,
  currency: 'ARS',
  label: '$24.990',
  compareAtLabel: '$49.990',
  perModelLead: '31 modelos por $24.990',
  perModelHighlight: 'Menos de $807 por modelo',
  perModelNote: 'Promedio dentro de la colección completa',
  note: 'Pago único',
  delivery: 'Después del pago, accedés al enlace de descarga de todos los archivos.',
} as const

export const BUY_LABEL = `Quiero Pequeñas Puntadas™ — ${PRICE.label}`
